import { Pipe, PipeTransform } from '@angular/core';
import { Pageable } from '@ngx-hal/models';

@Pipe({
  name: 'pageParams',
  standalone: false
})
export class PageParamsPipe implements PipeTransform {
  /**
   * Transforms a `Pageable` object into an object containing string representations
   * of the `page` and `size` properties, if they are defined.
   *
   * @param page - An optional `Pageable` object containing pagination information.
   * @returns An object with optional `page` and `size` properties as strings.
   */
  transform(page?: Pageable): { page?: string; size?: string } {
    return {
      ...(page?.page ? { page: `${page.page}` } : {}),
      ...(page?.size ? { size: `${page.size}` } : {}),
    };
  }
}
